export default {
  OTP: 'otp',
  PASSWORD: 'password',
  OTP_OR_PASSWORD: 'otp_password',
};
